/* eslint-disable
    default-case,
    func-names,
    no-shadow,
    no-underscore-dangle,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const moduleDeps = [require('data/util').name, require('data/model/ledgerCategory').name];

const ledgerCategoryCollectionDeps = ['Collection', 'LedgerCategory'];

const ledgerCategoryCollection = function (Collection, LedgerCategory) {
  let LedgerCategoryCollection;
  return (LedgerCategoryCollection = (function () {
    LedgerCategoryCollection = class LedgerCategoryCollection extends Collection {
      static initClass() {
        this.prototype.$id = 'single';
        this.prototype.$resource = 'ledgeraccountcategory';
        this.prototype.$type = LedgerCategory;
      }

      $init() {
        super.$init();

        // Automatically fetch the first time this collection is created.
        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }

      getFunctionalLedgerName(categoryId) {
        switch (categoryId) {
          case '1':
            return 'Bank Account';
          case '3':
            return 'Credit Card';
          case '5':
            return 'Equity Account';
          case '6':
            return 'Revenue Statement Account';
          case '7':
            return 'Payroll Statement Account';
          case '8':
            return 'Cost of Sales';
        }
      }

      isPotentialFunctionalLedger(categoryId) {
        return ['1', '3', '5', '6', '7', '8'].includes(categoryId);
      }

      findIdByName(name) {
        return __guard__(
          this.$find(model => String(model.name) === String(name)),
          x => x.id,
        );
      }

      getRoleName(categoryId) {
        switch (categoryId) {
          case '1':
            return 'BANK_ACCOUNT';
          case '3':
            return 'CREDIT_CARD';
          case '5':
            return 'EQUITY_ACCOUNT';
          case '6':
            return 'STATEMENT_PROCESSING_ACCOUNT';
          case '7':
            return 'STATEMENT_PROCESSING_ACCOUNT';
          case '8':
            return 'STATEMENT_PROCESSING_ACCOUNT';
        }
      }
    };
    LedgerCategoryCollection.initClass();
    return LedgerCategoryCollection;
  })());
};

ledgerCategoryCollection.$inject = ledgerCategoryCollectionDeps;

module.exports = angular
  .module('bench.data.collection.ledgerCategory', moduleDeps)
  .factory('LedgerCategoryCollection', ledgerCategoryCollection);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
